// API Configuration
const getApiUrl = () => {
  // If accessing from localhost, use localhost
  if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    return 'http://localhost:5000';
  }
  // Otherwise, use the same origin as the frontend (nginx will proxy to backend)
  return window.location.origin;
};

export const API_BASE_URL = getApiUrl();